<template>
  <!-- 右击菜单组件 -->
  <div class="menuContent" v-show="show" v-click-echartsMenu="isShow">
    <div :style="styleMenu">
      <!-- <div>{{menu1Text}}</div> -->
      <download-excel :data="json_data" :fields="json_fields" name="U学商情数据导出.xls">
        <!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
        <!-- <el-button type="primary" size="small">导出EXCEL</el-button> -->
        <div>导出Excel数据</div>
      </download-excel>
    </div>
  </div>
</template>

<script>
import { base } from '@/common/js/base'; //公共js
export default {
  name: 'clickRightMenu',
  data() {
    return {
      show: false,
      styleMenu: {},
      menu1Text: '导出Excel',
      domID: null,
      excelData: null,
      json_fields: {}, //如果命名的标题有空格,需要用双引号
      json_data: [],
      json_meta: [
        [
          {
            ' key ': ' charset ',
            ' value ': ' utf- 8 '
          }
        ]
      ]
    };
  },
  watch: {
    excelData(val, oldVal) {
      this.exportExcel(val);
    }
  },
  methods: {
    isShow() {
      this.show = false;
    },
    exportExcel(val) {
      console.log(val)
      console.log(this.domID)
      switch (this.domID) {
        case 'area': //中国地图的Excel处理
          this.exportExcelArea(val);
          break;
        case 'dateBar': //柱状图(天/月/季)
          this.exportExcelDateBar(val);
          break;
        case 'bus': //业务饼图
          this.exportExcelBus(val);
          break;
        case 'zbf': //中标方(来源)饼图
          this.exportExcelZbf(val);
          break;
        case 'bar'://柱状图(企业分析)
          this.enterpriseExportExcelDateBar(val);
          break;
        case 'indexLineEchart_tongxin'://柱状图(首页)
        case 'indexLineEchart_dianli'://柱状图(首页)
        case 'indexLineEchart_government'://柱状图(首页)
          this.indexLineEchart(val);
          break;
        case 'indexPieEchart_tongxin'://饼图(首页)
        case 'indexPieEchart_dianli'://饼图(首页)
        case 'indexPieEchart_government'://饼图(首页)
          this.indexPieEchart(val);
          break;
        case"guild"://“企业分析”行业的第一个图
          this.companyExcelDate1(val);
          break;
        case"zhongbiao"://“企业分析”行业的第二个图
          this.companyExcelDate2(val);
          break;
        default:
          break;
      }
    },
    exportExcelArea(val) {
      this.json_fields = { 序号: 'index', 地域分布: 'province', 数量: 'number', 金额: 'money' };
      this.json_data = [];
      for (let u in val) {
        //由于看地图（数量和金额）不一样，所以对数量和金额有对应的属性名称变动
        if (val[u].money) {
          //按数量看地图
          this.json_data.push({ index: Number(u) + 1, province: val[u].name, number: val[u].value, money: new base().numFilter(val[u].money) });
        }
        if (val[u].number) {
          //按金额看地图
          this.json_data.push({ index: Number(u) + 1, province: val[u].name, number: val[u].number, money: new base().numFilter(val[u].value) });
        }
      }
    },
    exportExcelDateBar(val) {
      //dataX日期，dataY1数量，dataY2金额
      this.json_fields = { 序号: 'index', 时间: 'province', 数量: 'number', 金额: 'money' };
      this.json_data = [];
      for (let u = 0; u < val.dataY1.length; u++) {
        let param = {};
        param.index = Number(u) + 1;
        param.province = val.dataX[u];
        param.number = val.dataY1[u];
        param.money = new base().numFilter(val.dataY2[u]);
        this.json_data.push(param);
      }
    },
    exportExcelBus(val) {
      let tempVal = this.deepClone(val);
      this.json_fields = { 序号: 'index', 业务分类: 'province', 数量: 'number', 金额: 'money' };
      this.json_data = [];
      if (tempVal && tempVal.length > 0) {
       /* if (tempVal[0].money) {
          //排序
          tempVal.sort(function(a, b) {
            return b.value - a.value;
          });
        } */
        //排序
        tempVal.sort(function(a, b) {
          return Number(b.value) - Number(a.value);
        });
      }
      for (let u in tempVal) {
        if (tempVal[u].money) {
          //按数量
          this.json_data.push({ index: Number(u) + 1, province: tempVal[u].name, number: tempVal[u].value, money: new base().numFilter(tempVal[u].money) });
        }
        if (tempVal[u].number) {
          //按金额
          this.json_data.push({ index: Number(u) + 1, province: tempVal[u].name, number: tempVal[u].number, money: new base().numFilter(tempVal[u].value) });
        }
      }
    },
    exportExcelZbf(val) {
        let tempVal = this.deepClone(val);
        this.json_fields = { 序号: 'index', 来源: 'province', 数量: 'number', 金额: 'money' };
        this.json_data = [];
        if (tempVal && tempVal.length > 0) {
         /* if (tempVal[0].money) {
            //排序
            tempVal.sort(function(a, b) {
              return b.value - a.value;
            });
          } */
          //排序
          tempVal.sort(function(a, b) {
            return Number(b.value) - Number(a.value);
          });
        }
        for (let u in tempVal) {
          if (tempVal[u].money) {
            //按数量
            this.json_data.push({ index: Number(u) + 1, province: tempVal[u].name, number: tempVal[u].value, money: new base().numFilter(tempVal[u].money) });
          }
          if (tempVal[u].number) {
            //按金额
            this.json_data.push({ index: Number(u) + 1, province: tempVal[u].name, number: tempVal[u].number, money: new base().numFilter(tempVal[u].value) });
          }
        }
    },
    enterpriseExportExcelDateBar(val){
      let tempVal = this.deepClone(val);
      this.json_fields = { 序号: 'index', 业务分类: 'province', 数量: 'number', 金额: 'money' };
      this.json_data = [];
    },
    indexLineEchart(val){
      let tempVal = this.deepClone(val);
      this.json_fields = { 序号: 'index', 时间: 'province', 数量: 'number', 金额: 'money' };
      this.json_data = [];
      for (let u = 0; u < tempVal.dataArray.length; u++) {
        let param = {};
        param.index = Number(u) + 1;
        param.province = tempVal.dataArray[u];
        param.number = tempVal.xyAxisArray[0].data[u];
        param.money = new base().numFilter(tempVal.xyAxisArray[1].data[u]);
        this.json_data.push(param);
      }
    },
    indexPieEchart(val){
        this.json_fields = { 序号: 'index', 来源: 'province', 数量: 'number', 金额: 'money' };
        this.json_data = [];
        for (let u = 0; u < val.sourceList.length; u++) {
          let param = {};
          param.index = Number(u) + 1;
          param.province = val.sourceList[u].name;
          param.number = val.sourceList[u].count;
          param.money = new base().numFilter(val.sourceList[u].totalMoney);
          this.json_data.push(param);
        }
    },
    companyExcelDate1(val){
      this.json_fields = { 序号: 'index', 来源: 'name', 数量: 'value', 金额: 'money' };
      this.json_data = [];
      for (let u in val) {
        if (val[u].money) {
          //按数量看
          this.json_data.push({ index: Number(u) + 1, name: val[u].name, value: val[u].value, money: new base().numFilter(val[u].money) });
        }
        if (val[u].number) {
          //按金额看
          this.json_data.push({ index: Number(u) + 1, name: val[u].name, value: val[u].number, money: new base().numFilter(val[u].value) });
        }
      }
    },
    companyExcelDate2(val){
      this.json_fields = { 序号: 'index', '中标&候选': 'name', 数量: 'value', 金额: 'money' };
      this.json_data = [];
      for (let u in val) {
        if (val[u].money||val[u].money==0) {
          //按数量看
          this.json_data.push({ index: Number(u) + 1, name: val[u].name, value: val[u].value, money: new base().numFilter(val[u].money) });
        }
        if (val[u].number||val[u].number==0) {
          //按金额看
          this.json_data.push({ index: Number(u) + 1, name: val[u].name, value: val[u].number, money: new base().numFilter(val[u].value) });
        }
      }
    },
    //深度克隆
    deepClone(obj) {
      var str,
        newobj = obj.constructor === Array ? [] : {};
      //constructor 属性返回对创建此对象的数组函数的引用。创建相同类型的空数据
      if (typeof obj !== 'object') {
        return;
      } else {
        for (var i in obj) {
          if (typeof obj[i] === 'object') {
            //判断对象的这条属性是否为对象
            newobj[i] = this.deepClone(obj[i]); //若是对象进行嵌套调用
          } else {
            newobj[i] = obj[i];
          }
        }
      }
      return newobj; //返回深度克隆后的对象
    }
  }
};
</script>

<style scoped>
.menuContent {
  position: relative;
  z-index: 9999;
}
.menuContent div {
  position: absolute;
  width: 30%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: #fff;
  color: #000;
}
.menuContent div div div {
  padding: 7px 10px;
  width: 100%;
}
.menuContent div div div:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/echarts/clickRightMenu.vue